import { Component , OnInit, LOCALE_ID, Inject, AfterViewInit, HostListener}          from '@angular/core';
import { Location }                     from '@angular/common'; //LocationStrategy, PathLocationStrategy
import { AuthService }                from './auth/ind/auth.service';
import { OrgAuthService }             from './auth/org/orgauth.service';
import { AdmAuthService }             from './auth/adm/admauth.service';
import { HttpClient } from '@angular/common/http';
//import { Http, Response, 
//        Headers, RequestOptions }     from '@angular/http';
import { environment }                from '../environments/environment';
import { User }                       from './_models/index';
//import { FlashMessagesService } from 'angular2-flash-messages';
//import { NgFlashService } from 'ng-flash';
//import { ToastrModule } from 'ngx-toastr';
//@import '~sass/variables';
declare var $: any;

@Component({
  selector: 'app-root',
  providers: [ AuthService, OrgAuthService, AdmAuthService, Location ],  
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit, AfterViewInit{
  gobutton =false;
  selectedLanguage = "";
  languages = environment.languages;
  showLang = environment.showLang;  
  envname = environment.envname;
  public user: User;
  first = { content1: 'On', content2: 'Reference' };
  style = "color: 'green'; font_weight: bold; font_size: 5px";
  color = 'transparent';//color = 'green'; //#f8f8f8;
  font_weight = 'bold';
  font_size = '1px';
  version = environment.version;
  public isPdfPath: boolean = false;  
  public isOrgPath: boolean = false;
  public isAdmPath: boolean = false; 
  dropdownOpenInd: boolean = false;
  dropdownOpenOrg: boolean = false;
  dropdownOpenAdm: boolean = false;
  navbarOpen: boolean = false;
  //public isQPath: boolean;
  constructor(public auth: AuthService, public authOrg: OrgAuthService, 
    public authAdm: AdmAuthService, private location: Location, @Inject(LOCALE_ID) private _locale: string)
     //private _ngFlashService: NgFlashService) 
     //private toastr: ToastrService  //this.toastr.success('Saved successfully');
  { 
    this.location = location; 
    this.selectedLanguage = _locale;
    //alert('AppLocale: '+_locale);
  }

  ngOnInit(){ //console.log('Step 1');
    var path = this.location.path(false);
    //this.isQPath = ( path.includes('/q' ) )? true : false ;
    //this.isQPath = ( path.indexOf('/q') >= 0 )? true : false ;
    this.isPdfPath = ( path.indexOf('/pdf') >= 0 )? true : false ;
    if (this.isPdfPath){
      return;
    }
    //console.log('Step 2');
    //this.isOrgPath = ( path.includes('/org' ) )? true : false ;
    this.isOrgPath = ( path.indexOf('/org') >= 0 )? true : false ;
    if (this.isOrgPath){
      return;
    }
    
    
    //this.isAdmPath = ( path.includes('/adm' ) )? true : false ;
    this.isAdmPath = ( path.indexOf('/adm' ) >= 0 )? true : false ;
    if (this.isAdmPath){
      return;
    }
    
    //    return (this.location.isCurrentPathEqualTo('/org') || this.location.isCurrentPathEqualTo('/org-login')) ? true : false;
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.dropdownOpenInd = false;
    this.dropdownOpenOrg = false;
    this.dropdownOpenAdm = false;
  }
  closeNavbar() {
    this.navbarOpen = false;
  }
  toggleDropdown(type: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.dropdownOpenInd = type === 'ind' ? !this.dropdownOpenInd : false;
    this.dropdownOpenOrg = type === 'org' ? !this.dropdownOpenOrg : false;
    this.dropdownOpenAdm = type === 'adm' ? !this.dropdownOpenAdm : false;
  }

  toggleNavbar(event: Event) {
    event.stopPropagation();
    this.navbarOpen = !this.navbarOpen;
  }
  ngAfterViewInit() {

    $(document).on('click', '.navbar li a', function(event: any) {
      if ($(".navbar-collapse").is(":visible") && $(".navbar-toggle").is(":visible") &&
          event.currentTarget.className != "dropdown-toggle") {
        $('.navbar-toggle').click();
        event.stopPropagation();
      }
    });
  }

  ngAfterViewChecked(){
    /*$('.navbar li a').on('click', function(event){
      if ($(".navbar-collapse").is(":visible") && $(".navbar-toggle").is(":visible") && event.currentTarget.className != "dropdown-toggle") {
        $('.navbar-toggle').click() //bootstrap 3.x         
        event.stopPropagation();
      }
    });

    $('#mainapp').click(function(event){
     //this._flashMessagesService.show('event.data.value:'+event.data.value, { cssClass: 'alert-success', timeout: 10000 });
     //console.log('event.currentTarget:'+event.currentTarget.className);
      if ($(".navbar-collapse").is(":visible") && $(".navbar-toggle").is(":visible")) {// && event.currentTarget.className != "dropdown-toggle"
        $('.navbar-collapse').collapse('toggle');
        event.stopPropagation();
      }
    })*/
  }

  updateLanguage(){
    if (this.selectedLanguage != this._locale){
      //alert('Changing to: '+environment.clienturl+this.selectedLanguage);
      window.location.href = environment.clienturl+this.selectedLanguage;
    }
  }
  goToWebsite(){
    window.location.href = environment.website;
  }
  goBack(){
    window.history.back();
  }
  goForward(){
    window.history.forward();
  }
}

